<template>
  <main class="main configurations">
    <div class="white-panel">
      <header class="panel-header">
        <h2 class="panel-title">
          {{ $t('choose.service') }}
        </h2>
      </header>
      <div
        v-if="availableServices"
        class="config-panel panel-scroll"
      >
        <div
          v-for="service in availableServices"
          :key="service.id"
          class="row space-between"
        >
          <div class="config-label">
            {{ service.title[locale] }}
          </div>
          <div
            class="next-step"
            @click="$router.push({ name: 'ServicePage', params: { serviceID: service.id } })"
          />
        </div>
      </div>
    </div>
  </main>
</template>
<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import EditService from '@/components/modals/EditService'
export default {
  computed: {
    ...mapGetters([
      'availableServices'
    ]),
    ...mapState([
      'loggedUser',
      'services'
    ]),
    locale () {
      return this.$i18n.locale()
    }
  },
  created () {
    if (this.availableServices && this.availableServices.length === 1) {
      this.$router.push({ name: 'ServicePage', params: { serviceID: this.availableServices[0].id } })
    }
  },
  methods: {
    ...mapActions([
      'fetchServices',
      'removeService'
    ]),
    async deleteService (serviceID) {
      this.removeService({ serviceID })
    },
    async editService (service) {
      this.$showModal('EditDervice', EditService, service)
    }
  }
}
</script>
